import React, { useContext } from 'react';
import './chat.css';
import { startChatSession } from './startChatSession';
import { ChatReasonContext } from '../../context/HomePageContext';
import { Button, ButtonTheme } from '../common/button/Button';
import { ButtonContainer } from '../common/buttonContainer/ButtonContainer';
import { useFlags } from 'launchdarkly-react-client-sdk';
import Select, { SingleValue } from 'react-select';

export default function Chat() {
  const { chatReason, setChatReason } = useContext(ChatReasonContext);
  const { enableDecommissioning } = useFlags();
  const { enableSOneSiteDecommission } = useFlags();
  const { enableAutomatedTcsoElecOnly } = useFlags();
  const { enableAutomatedTcsoDualFuel } = useFlags();
  const initialChatMessage: string = `Hi,

I can see you need assistance with the following:
${chatReason}

Please wait while we redirect you to an agent.
`;

  function selectReasonHandler(selectedChatReason: SingleValue<{ value: string; label: string }>) {
    setChatReason('');
    if (selectedChatReason) {
      setChatReason(selectedChatReason.value);
    }
  }

  async function startChatHandler() {
    await startChatSession({ message: initialChatMessage, mpxn: '', chatReason });
  }

  function matchChatReason() {
    return chatReasonOptions.find((option) => option.value === chatReason);
  }

  function shouldRenderButtons() {
    switch (chatReason) {
      case 'Engineer comms checker':
        return false;
      case 'Decommission a Meter':
        return enableDecommissioning !== true;
      case S1_FULL_SITE_DECOMMISSION:
        return enableSOneSiteDecommission !== true;
      case TCSO:
        return enableAutomatedTcsoElecOnly !== true;
      case TCSO_DUAL_FUEL:
        return enableAutomatedTcsoDualFuel !== true;
      default:
        return true;
    }
  }

  return (
    <form
      name="contactDetail"
      id="contactDetails"
      className="contact-details-container"
      action="/index.html"
      onSubmit={(e) => e.preventDefault()}
      data-testid="chat-form"
    >
      <p className="chat-reasons-p">What issue are you having?</p>
      <Select
        id="select-chat-reason"
        placeholder="Select issue"
        className="chat-reason-select-container"
        classNamePrefix="chat-reason-select"
        isSearchable={true}
        options={chatReasonOptions}
        onChange={selectReasonHandler}
        value={matchChatReason()}
      />
      <span id="accessDeniedError" style={{ display: 'none' }} className="errorMessage">
        Oops, try again in 10 seconds
      </span>
      {shouldRenderButtons() && (
        <ButtonContainer>
          <Button
            buttonId={'startChatFirstPage'}
            buttonText={'Start'}
            buttonTheme={ButtonTheme.PRIMARY}
            isButtonEnabled={chatReason !== ''}
            dataTestId={'chat-start-chat-btn'}
            onClickHandler={startChatHandler}
          />
        </ButtonContainer>
      )}
    </form>
  );
}

export const S1_FULL_SITE_DECOMMISSION = 'Full s1 site ONLY (decommission)';
export const TCSO = 'TCSO for elec sites only';
export const TCSO_DUAL_FUEL = 'TCSO for dual fuel sites only';

export const chatReasonOptions = [
  { value: 'Alt-HAN query', label: 'Alt-HAN query', queue: '2' },
  { value: 'Checking progress', label: 'Checking progress', queue: '1' },
  {
    value: 'Checking site details',
    label: 'Checking site details',
    queue: '1',
  },
  {
    value: 'Customer is off supply',
    label: 'Customer is off supply',
    queue: '2',
  },
  {
    value: 'Decommission a CH/IHD',
    label: 'Decommission a CH/IHD',
    queue: '2',
  },
  { value: 'Decommission a Meter', label: 'Decommission a Meter', queue: '2' },
  { value: 'Elec error', label: 'Elec error', queue: '2' },
  {
    value: 'Engineer comms checker',
    label: 'Engineer comms checker',
    queue: '1',
  },
  { value: 'Fault with IHD', label: 'Fault with IHD', queue: '2' },
  {
    value: S1_FULL_SITE_DECOMMISSION,
    label: S1_FULL_SITE_DECOMMISSION,
    queue: '1',
  },
  { value: 'Gas error', label: 'Gas error', queue: '2' },
  { value: 'Job query', label: 'Job query', queue: '2' },
  {
    value: 'Need commissioning sent',
    label: 'Need commissioning sent',
    queue: '1',
  },
  { value: 'Suspected no WAN', label: 'Suspected no WAN', queue: '2' },
  { value: TCSO, label: TCSO, queue: '2' },
  { value: TCSO_DUAL_FUEL, label: TCSO_DUAL_FUEL, queue: '2' },
];
